import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, Home } from "lucide-react";

export default function NotFound() {
  useEffect(() => { document.title = "Page not found · TicketsPro.app"; }, []);
  return (
    <div className="min-h-screen bg-[#0d1626] flex flex-col overflow-x-hidden" data-testid="not-found-page">
      <div className="border-b border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-white font-bold">TicketsPro.app</Link>
          <Link to="/events" className="text-white/80 hover:text-white text-sm font-medium">Browse events</Link>
        </div>
      </div>
      <div className="relative flex-1 flex items-center overflow-hidden">
        <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#2ec9c9]/10 blur-3xl" />
        <div className="absolute -left-24 bottom-0 w-96 h-96 rounded-full bg-[#8b5cf6]/10 blur-3xl" />
        <div className="relative max-w-6xl mx-auto px-6 py-24 w-full">
          <p className="text-sm uppercase tracking-widest text-[#2ec9c9] mb-3">Error 404</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
            This page has left the building.
          </h1>
          <p className="text-base sm:text-lg text-[#b7c2d3] mt-5 max-w-xl">
            The link you followed is broken or the page has moved. The show must go on though — let's find you something to see.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/events" data-testid="notfound-events-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#2ec9c9] text-[#0d1626] font-semibold px-7 py-3 hover:bg-[#26b3b3] transition-colors">
              <CalendarDays size={18} /> Browse events <ArrowRight size={16} />
            </Link>
            <Link to="/" data-testid="notfound-home-btn"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 text-white px-7 py-3 hover:bg-white/5 transition-colors">
              <Home size={18} /> Back home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
